import React from "react";
import Link from "next/link";
import { Grid } from "@mui/material";
import styles from "./how_it_work.module.scss";
import { ReactSVG } from "react-svg";

export const ElearningListingHowItWorks = () => {
  return (
    <section className={styles.section_how_it_work}>
      <div className="container">
        <h2 className={styles.title}>
          How it
          <span className={"color-orange"}>Works</span>
        </h2>
        <Grid
          container
          spacing={{ xs: 3, sm: 3, md: 4 }}
          justifyContent="center"
        >
          <Grid item xs={12} sm={6} md={3}>
            <div className={styles.test_card}>
              <ReactSVG
                className={styles.test_icon}
                src="/assets/images/elearning/listing/add-friend.svg"
              />
              <div className={styles.test_desc}>Enroll for the course</div>
            </div>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <div className={styles.test_card}>
              <ReactSVG
                className={styles.test_icon}
                src="/assets/images/elearning/listing/online-class.svg"
              />

              <div className={styles.test_desc}>
                Access to the live classes and tons of offerings
              </div>
            </div>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <div className={styles.test_card}>
              <ReactSVG
                className={styles.test_icon}
                src="/assets/images/elearning/listing/checked.svg"
              />

              <div className={styles.test_desc}>
                Secure great marks in your exam
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </section>
  );
};

export default ElearningListingHowItWorks;
